import React, { FC, useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import { APP_PATHS } from '../../../electrolyse-shared/app-paths';
import { IProject } from '../../../electrolyse-shared/interfaces';
import { useGetProject } from '../../hooks/useGetProject';
import { useAsyncEffect } from '../../hooks/useAsyncEffect';
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs';
import { useLoading } from '../../hooks/useLoading';
import { ScreenLayout } from '../global/ScreenLayout';
import { NotFound } from '../global/NotFound';
import { Breadcrumbs } from '../global/Breadcrumbs';
import { ContentWrapper } from '../global/ContentWrapper';
import { ProjectNav } from '../global/ProjectNav';
import { Skeleton } from '../ui/loading/Skeleton';
import { ProjectInfo } from '../global/ProjectInfo';

interface IProps extends RouteComponentProps {
  id?: string;
}

export const ProjectScreen: FC<IProps> = ({ id }) => {
  const { setLoading, loading } = useLoading();
  const [project, setProject] = useState<IProject | null>(null);
  const { getProjectById } = useGetProject();
  const { setBreadcrumbs } = useBreadcrumbs();
  const [notFound, setNotFound] = useState(false);

  useAsyncEffect(async () => {
    setLoading(true);
    try {
      const project = await getProjectById(id ?? '');
      setProject(project);
      setBreadcrumbs([
        { title: 'Projects', path: APP_PATHS.PROJECTS },
        {
          title: project.name,
          path: APP_PATHS.PROJECT.replace(':id', id ?? ''),
        },
      ]);
      if (!project) {
        setNotFound(true);
      }
      return setLoading(false);
    } catch (e) {}
    setNotFound(true);
    setLoading(false);
  }, []);

  if (notFound) {
    return <NotFound />;
  }

  return (
    <ScreenLayout title={<Breadcrumbs />}>
      <ProjectNav projectId={id ?? ''} />
      {loading && !project ? (
        <ContentWrapper>
          <Skeleton />
        </ContentWrapper>
      ) : (
        <ProjectInfo project={project} />
      )}
    </ScreenLayout>
  );
};
